import React from "react";
import { Placeholder } from "@bloomberg/media-ui-article";

type PlaceholderImageProps = {
  width?: string | number;
  height?: string | number;
  className?: string;
};

const PlaceholderImage = (props: PlaceholderImageProps) => {
  const { width, height, className } = props;
  const dimensions = { width, height };

  return (
    <Placeholder>
      <div style={dimensions} className={className}>
        <Placeholder.Image />
      </div>
    </Placeholder>
  );
};

export default PlaceholderImage;
